import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=87eacdd8&scoped=true&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"
import style0 from "swiper/dist/css/swiper.css?vue&type=style&index=0&lang=css&"
import style1 from "./Article.vue?vue&type=style&index=1&id=87eacdd8&scoped=true&lang=css&"
import style2 from "./Article.vue?vue&type=style&index=2&id=87eacdd8&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eacdd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87eacdd8')) {
      api.createRecord('87eacdd8', component.options)
    } else {
      api.reload('87eacdd8', component.options)
    }
    module.hot.accept("./Article.vue?vue&type=template&id=87eacdd8&scoped=true&", function () {
      api.rerender('87eacdd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/articles/Article.vue"
export default component.exports